const borderosMenu = {
    label: 'Borderôs',
    icon: 'pi pi-dollar',
    to: '/autorizadorfinanceiro/borderos',
    rules: ['BORDEROS-00'],
};

export { borderosMenu };
